import { render } from "./BoardList.vue?vue&type=template&id=1517832b&scoped=true&ts=true"
import script from "./BoardList.vue?vue&type=script&lang=ts"
export * from "./BoardList.vue?vue&type=script&lang=ts"

import "./BoardList.vue?vue&type=style&index=0&id=1517832b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1517832b"]])

export default __exports__